import GameModel from "./GameModel";
import Config from "../../../../../shared/src/ranj/app/config/Config";
import BaseSaveModel from "../../../../../shared/src/ranj/equalture/savegame/BaseSaveModel";

export default class SaveModel extends BaseSaveModel {

    /**
     * 
     * @param {GameModel} gameModel 
     * @param {Config} config 
     */
    constructor(gameModel, config) {
        super(config);
        this._gameModel = gameModel;
        this._config = config;
    }

    _createMinigameSaveGame() {
        return {
            elapsed: this._gameModel.elapsedTime,
            index: this._gameModel.puzzleIndex,
            puzzle: this._gameModel.puzzle.toObject()
        };
    }
};
